import React from 'react';
import { Link } from 'react-router-dom';
import './Card.css';

export function Card({ children, className = '', padding = 'md', hover = false, onClick, ...props }) {
  return (
    <div
      className={`card card-pad-${padding} ${hover ? 'card-hover' : ''} ${onClick ? 'card-clickable' : ''} ${className}`}
      onClick={onClick}
      {...props}
    >
      {children}
    </div>
  );
}

export function CardHeader({ title, subtitle, action, icon }) {
  return (
    <div className="card-header">
      <div className="card-header-left">
        {icon && <div className="card-header-icon">{icon}</div>}
        <div>
          <h3 className="card-title">{title}</h3>
          {subtitle && <p className="card-subtitle">{subtitle}</p>}
        </div>
      </div>
      {action && <div className="card-header-action">{action}</div>}
    </div>
  );
}

export function StatCard({ label, value, sub, icon, color = 'violet', trend, to }) {
  const inner = (
    <>
      {icon && <div className="stat-card-icon">{icon}</div>}
      <div className="stat-card-body">
        <div className="stat-card-value">{value}</div>
        <div className="stat-card-label">{label}</div>
        {sub && <div className="stat-card-sub">{sub}</div>}
        {trend !== undefined && (
          <div className={`stat-card-trend ${trend >= 0 ? 'up' : 'down'}`}>
            {trend >= 0 ? '↑' : '↓'} {Math.abs(trend)}%
          </div>
        )}
        {to && <div className="stat-card-link">Voir →</div>}
      </div>
    </>
  );
  if (to) {
    return (
      <Link to={to} className={`stat-card stat-card-${color} stat-card-clickable`} style={{ textDecoration: 'none' }}>
        {inner}
      </Link>
    );
  }
  return <div className={`stat-card stat-card-${color}`}>{inner}</div>;
}
